import { constants, actions } from 'ducks-helpers';

//  SUFFIXES
// [
//   'LOADING',
//   'PENDING',
//   'SUCCESS',
//   'ERROR',
//   'FAILED',
//   'CANCELED'
// ]

export const TYPE = constants('reports/cash_collection', [
    '~FETCH_CASH_COLLECTION_REPORT',
    'EXPORT_TO_EXCEL'
]);

export const ACTION = actions(TYPE);
